"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var discountLabelStyles = styles_1.makeStyles(function (theme) { return ({
    boldLabel: {
        fontWeight: 'bold',
        fontSize: theme.typography.fontMD,
        wordBreak: 'break-word',
    },
    label: {
        fontSize: theme.typography.fontMD,
        wordBreak: 'break-word',
    },
}); }, { name: 'Summary_DiscountPriceLabel' });
exports.default = discountLabelStyles;
